var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('xlsx-workbook',[_vm._l((_vm.sheets),function(sheet){return _c('xlsx-sheet',{key:sheet.name,attrs:{"collection":sheet.data,"sheet-name":sheet.name}})}),_c('xlsx-download',{attrs:{"filename":_vm.fname}},[_c('v-btn',{staticClass:"success"},[_vm._v("backup data")])],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }